import { push } from 'react-router-redux'
import jwtDecode from 'jwt-decode';
import cookies from 'js-cookie';
import { toastr } from 'react-redux-toastr';

import { createReducer } from '../utils';
import { hideAuthDialogs } from './modals';
import { auth } from './socket';
import { fetchUser, resetUser } from './user';

export const LOGIN = 'bamboo-developments/auth/LOGIN';
export const LOGIN_SUCCESS = 'bamboo-developments/auth/LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'bamboo-developments/auth/LOGIN_FAILURE';
const LOGOUT = 'bamboo-developments/auth/LOGOUT';

const initialState = {
  email: null,
  isAuthenticated: false,
  isAuthenticating: false,
  isError: false,
  token: null,
};

const base64EncodeUnicode = str =>
  btoa(encodeURIComponent(str)
    .replace(
      /%([0-9A-F]{2})/g,
      (match, p1) => String.fromCharCode('0x' + p1)
  ));

export function receiveToken(token) {
  return (dispatch) => {
    cookies.set('token', token, { expires: 7 });
    dispatch(auth(token));
    dispatch(fetchUser(token));
    dispatch({ type: LOGIN_SUCCESS, payload: token});
  };
}

export function login({ email, password }) {
  return (dispatch) => {
    dispatch({ type: LOGIN });

    const credentials = base64EncodeUnicode(`${email}:${password}`);

    var options = { 
      method: 'POST',
      headers: {
        'Authorization': `Basic ${credentials}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        grant_type: 'client_credentials',
      }),
    };

    return fetch('/api/token', options)
      .then(response => response.json())
      .then(payload => {
        toastr.light('', 'You have signed in', {
          icon: 'success',
          status: 'success',
        });
        dispatch(push('/development'));
        dispatch(receiveToken(payload.access_token));
        dispatch(hideAuthDialogs());
      })
      .catch(error => dispatch({ type: LOGIN_FAILURE, error}));
  };
}

export function logout() {
  return (dispatch) => {
    cookies.remove('token');
    dispatch({ type: LOGOUT });
    dispatch(resetUser());
    toastr.light('', 'You have logged out', {
      icon: 'success',
      status: 'success',
    });
  };
}

export default createReducer(initialState, {
  [LOGIN]: state => ({
    ...state,
    isAuthenticating: true,
    isError: false,
  }),
  [LOGIN_SUCCESS]: (state, payload) => {
    const decoded = jwtDecode(payload, { complete: true });
    return {
      ...state,
      email: decoded.sub,
      isAuthenticated: true,
      isAuthenticating: false,
      token: payload,
    };
  },
  [LOGIN_FAILURE]: state => {
    return {
      ...state,
      isAuthenticated: false,
      isAuthenticating: false,
      isError: true,
    };
  },
  [LOGOUT]: state => ({
    ...state,
    ...initialState,
  }),
});



// WEBPACK FOOTER //
// ./src/redux/auth.js